{
	"description": "Service Collection Entitlement template",
	"features": [
		{
			"featureId": "provided-allowances",
			"domain": "BILLING",
			"value": {
				"allowances": [
					{
						"reference": "allowance_indexed-document",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "indexed-document",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 625,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 625,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					},
					{
						"reference": "allowance_ai-credit",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "ai-credit",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 150,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 150,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					},
					{
						"reference": "allowance_assets-objects",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "assets-objects",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 500000
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 500000
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					},
					{
						"reference": "allowance_automation-credits",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "automation-credits",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 7500,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 7500,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "agent"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					}
				]
			}
		}
	]
}
